/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NatureFxFireIcon16Light } from './NatureFxFireIcon16Light';
import { NatureFxFireIcon16Regular } from './NatureFxFireIcon16Regular';
import { NatureFxFireIcon16Solid } from './NatureFxFireIcon16Solid';
import { NatureFxFireIcon20Light } from './NatureFxFireIcon20Light';
import { NatureFxFireIcon20Regular } from './NatureFxFireIcon20Regular';
import { NatureFxFireIcon20Solid } from './NatureFxFireIcon20Solid';
import { NatureFxFireIcon24Regular } from './NatureFxFireIcon24Regular';
import { NatureFxFireIcon24Solid } from './NatureFxFireIcon24Solid';
import { NatureFxFireIcon32Regular } from './NatureFxFireIcon32Regular';
import { NatureFxFireIcon64Regular } from './NatureFxFireIcon64Regular';
var sizes = {
    16: {
        light: NatureFxFireIcon16Light,
        regular: NatureFxFireIcon16Regular,
        solid: NatureFxFireIcon16Solid,
    },
    20: {
        light: NatureFxFireIcon20Light,
        regular: NatureFxFireIcon20Regular,
        solid: NatureFxFireIcon20Solid,
    },
    24: {
        regular: NatureFxFireIcon24Regular,
        solid: NatureFxFireIcon24Solid,
    },
    32: {
        regular: NatureFxFireIcon32Regular,
    },
    64: {
        regular: NatureFxFireIcon64Regular,
    },
};
export var NatureFxFireIcon = forwardRef('NatureFxFireIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
